"use strict";

angular.module("internal.exams").directive("internalExamSessionsNavigation", [
    '$stateParams',
    function ($stateParams) {
        return {
            restrict: "E",
            scope: {
                examSessionID: "@?"
            },
            templateUrl:
                paths.app +
                "exams/components/exam-sessions-navigation/exam-sessions-navigation.html",
            replace: true,
            compile: function () {
                return {
                    pre: function (scope) {
                        scope.examSessionID = $stateParams.examSessionID;
                    }
                }
            }
        };
    }
]);
